import type { FC } from 'react';
import ConfirmationModal from 'components/molecules/common/modals/ConfirmationModal';
import { TPO_SAVE_AS_ORIGINAL_MODAL } from '../../../config/testIds';
import { useTpoGenConfig } from '../../../context/CustomerConfigContext';
import useSaveAsOriginalMutation, {
    type SaveAsOriginalResponse,
} from '../hooks/mutations/useSaveAsOriginalMutation';

export interface SaveAsOriginalModalProps {
    open: boolean;
    onClose: () => void;
    optimizedPlanId: string;
    onSuccess: (data: SaveAsOriginalResponse) => void;
}

const SaveAsOriginalModal: FC<SaveAsOriginalModalProps> = ({ open, onClose, optimizedPlanId, onSuccess }) => {
    const { labels } = useTpoGenConfig();

    const { mutate: saveAsOriginal, isPending } = useSaveAsOriginalMutation({
        onSuccess: (data) => {
            onClose();
            onSuccess(data);
        },
    });

    return (
        <ConfirmationModal
            data-testid={TPO_SAVE_AS_ORIGINAL_MODAL}
            open={open}
            onCancel={onClose}
            onSubmitClick={() => saveAsOriginal(optimizedPlanId)}
            okText="Save"
            okButtonProps={{
                type: 'primary',
                loading: isPending,
                style: { borderRadius: 6 },
            }}
            loading={isPending}
            title={labels.modals.saveAsOriginalTitle}
            subTitle={labels.modals.saveAsOriginalQuestion}
            description={
                <div className="bg-[#fafafa] rounded-lg p-2">
                    <p className="text-sm text-[#18181b]">{labels.modals.saveAsOriginalDescription}</p>
                </div>
            }
            width={520}
        />
    );
};

SaveAsOriginalModal.displayName = 'SaveAsOriginalModal';
export default SaveAsOriginalModal;
